// extracted by mini-css-extract-plugin
module.exports = {"lockIcon":"VerifyCode_lockIcon__ExVMj","btn":"VerifyCode_btn__Qni16","serverError":"VerifyCode_serverError__2Dytm","logo":"VerifyCode_logo__2LyGI"};